export const materialBrand = {
  name: 'Material / Brand',
  width: '1fr',
  filter: (val: string, row: any) => `${row.item?.material?.brand ? row.item.material.brand : (row.item?.material?.name || '')}`,
};

export const bomItemMaterialCode = {
  name: 'รหัสชิ้นส่วน',
  width: '1fr',
  filter: (val: string, row: any) => `${row.item.bom_item.material.code ? row.item.bom_item.material.code : ''}`,
};

export const materialCode = {
  name: 'รหัสชิ้นส่วน',
  width: '1fr',
  filter: (val: string, row: any) => `${row.item.material.code ? row.item.material.code : ''}`,
};

export const bomItemMaterialBrand = {
  name: 'Material / Brand',
  width: '1fr',
  filter: (val: string, row: any) => `${row.item.bom_item?.material?.brand ? row.item.bom_item.material.brand : (row.item.bom_item?.material?.name || '')}`,
};

export const bomItemDrawingNo = {
  name: 'Drawing No./Part No.',
  width: '10rem',
  filter: (val: string, row: any) => `${row.item.bom_item.drawing_no || row.item.material.code}`,
};
